// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__Oizr0","loader":"Loader_loader__rBaL5"};